<router-outlet></router-outlet>
<app-side-bar-menu></app-side-bar-menu>

<input type="hidden" id="userId" value="{{onesignal.userId$ | async}}">
<input type="hidden" id="isSuscribe" value="{{onesignal.isSubscribe$ | async}}">
